var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import React, { useCallback, useState, useRef, useEffect } from 'react';
import { Button, Input, message, Tooltip } from 'antd';
import IconFont from '../IconFont';
export default function TagNode(_a) {
    var _this = this;
    var user = _a.user, goBack = _a.goBack, onSaveUserTag = _a.onSaveUserTag, onGetTagList = _a.onGetTagList, onSetTag = _a.onSetTag;
    var _b = useState(''), tagName = _b[0], setTagName = _b[1];
    var _c = useState([]), tagList = _c[0], setTagList = _c[1];
    var _d = useState(''), errMsg = _d[0], setErrMsg = _d[1];
    var _e = useState(user && user.tagInfoList ? user.tagInfoList.map(function (i) { return i.tagId; }) : []), checkedTag = _e[0], setCheckedTag = _e[1];
    var _f = useState(false), newTagFlag = _f[0], setNewTagFlag = _f[1];
    var listRef = useRef(null);
    var handleAddTag = useCallback(function () {
        setNewTagFlag(true);
        setTagName('');
        setTimeout(function () {
            listRef.current && listRef.current.scrollTo(0, 0);
        }, 0);
    }, []);
    var clearSelect = useCallback(function () {
        setCheckedTag([]);
    }, []);
    var getData = useCallback(function () { return __awaiter(_this, void 0, void 0, function () {
        var _a, res, err, list;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, onGetTagList()];
                case 1:
                    _a = _b.sent(), res = _a[0], err = _a[1];
                    if (err) {
                        setErrMsg(err);
                        return [2 /*return*/];
                    }
                    list = res.tagList.sort(function (a, b) { return a.sortNum - b.sortNum; });
                    setTagList(list);
                    return [2 /*return*/, list];
            }
        });
    }); }, [onGetTagList]);
    useEffect(function () {
        getData();
        return function () { };
    }, [getData]);
    var confirmAdd = useCallback(function () { return __awaiter(_this, void 0, void 0, function () {
        var _a, res, err, list, newTag;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    setNewTagFlag(false);
                    if (!tagName) return [3 /*break*/, 3];
                    return [4 /*yield*/, onSetTag({ tagName: tagName })];
                case 1:
                    _a = _b.sent(), res = _a[0], err = _a[1];
                    if (err) {
                        console.error(err);
                        message.error(err);
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, getData()];
                case 2:
                    list = _b.sent();
                    newTag = list.find(function (item) { return item.name === tagName; });
                    if (newTag) {
                        setCheckedTag(__spreadArrays(checkedTag, [newTag.tagId]));
                    }
                    setTimeout(function () {
                        listRef.current && listRef.current.scrollTo(0, 0);
                    }, 0);
                    _b.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    }); }, [checkedTag, getData, onSetTag, tagName]);
    var handleTagNameChange = useCallback(function (e) {
        setTagName(e.target.value);
    }, []);
    var onSave = useCallback(function () {
        onSaveUserTag(user, checkedTag, tagList.filter(function (tag) { return checkedTag.includes(tag.tagId); }));
    }, [checkedTag, onSaveUserTag, tagList, user]);
    var handleCheckTag = useCallback(function (item) {
        if (checkedTag.length === 0) {
            checkedTag.push(item.tagId);
        }
        else {
            var exist = checkedTag.findIndex(function (i) { return i === item.tagId; });
            if (exist >= 0) {
                checkedTag.splice(exist, 1);
            }
            else {
                if (checkedTag.length >= 5) {
                    message.error('最多可选择5个分组');
                    return;
                }
                checkedTag.push(item.tagId);
            }
        }
        setCheckedTag(__spreadArrays(checkedTag));
    }, [checkedTag]);
    if (errMsg) {
        return (React.createElement("div", { style: {
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                height: '40vh',
                padding: 20,
            } },
            React.createElement("h4", null,
                React.createElement("span", null, errMsg))));
    }
    return (React.createElement("div", { className: "tag-modal-node" },
        React.createElement("div", { className: "tag-main-title", onClick: handleAddTag }, "+ \u65B0\u5EFA\u5206\u7EC4"),
        React.createElement("div", { className: "tag-list-wrap", ref: listRef },
            React.createElement("div", { className: "tag-item", onClick: clearSelect },
                React.createElement("div", { className: "tag-name" }, "\u65E0"),
                React.createElement("div", { className: "tag-switch" }, !checkedTag.length && (React.createElement(IconFont, { style: {
                        color: '#1686FF',
                    }, type: "iconjs_ic_check" })))),
            newTagFlag && (React.createElement("div", { className: "tag-item" },
                React.createElement("div", { className: "new-tag-wrap" },
                    React.createElement(Input, { placeholder: "\u6700\u591A20\u4E2A\u5B57", className: "tag-input", maxLength: 20, value: tagName, onChange: handleTagNameChange }),
                    React.createElement(Button, { onClick: confirmAdd, type: "text" }, "\u786E\u5B9A")))),
            tagList.map(function (tag) {
                return (React.createElement("div", { className: "tag-item", key: tag.tagId, onClick: handleCheckTag.bind(null, tag) },
                    React.createElement("div", { className: "tag-name" },
                        React.createElement(Tooltip, { title: tag.name }, tag.name)),
                    React.createElement("div", { className: "tag-switch" }, checkedTag.includes(tag.tagId) && (React.createElement(IconFont, { style: {
                            color: '#1686FF',
                        }, type: "iconjs_ic_check" })))));
            })),
        React.createElement("div", { className: "tag-modal-footer" },
            React.createElement(Button, { onClick: goBack, size: "small", style: {
                    marginRight: 10,
                } }, "\u53D6\u6D88"),
            React.createElement(Button, { onClick: onSave, size: "small", type: "primary" }, "\u4FDD\u5B58"))));
}
//# sourceMappingURL=Tag.js.map